<script setup lang="ts">
import { useRandomArtists, useRandomRegions } from '~/composables/showcase'

const { data: artists, suspense: artistsSuspense } = useRandomArtists(4)
const { data: regions, suspense: regionsSuspense } = useRandomRegions(10)

onServerPrefetch(() => Promise.all([artistsSuspense(), regionsSuspense()]))
</script>

<template>
  <div class="flex flex-col gap-36">
    <AlArtistMoreSection
      v-if="artists"
      :artists="
        artists.map((artist) => ({
          id: artist.id,
          name: artist.name,
          slug: `${artist.slug}-${artist.slug_id}`,
          thumbnail: {
            alt: artist.image_alt,
            src: artist.image_url,
          },
        }))
      "
    />

    <!-- TODO add small offer map -->

    <AlRegionSlider
      v-if="regions"
      title="Mehr Regionen"
      :regions="
        regions.map((region) => ({
          name: region.name,
          slug: `${region.slug}-${region.slug_id}`,
          thumbnail: {
            alt: region.image_alt,
            src: region.image_url,
          },
        }))
      "
    />
  </div>
</template>
